var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-page',{attrs:{"legendMobile":'modal',"filterMobile":'modal',"legendDesktop":'horizontal',"filterDesktop":'card',"useMaxWithRanking":true,"locationInfoShowOn":"hover"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d10adb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map/layouts/4.vue
// module id = null
// module chunks = 